module.exports = __webpack_public_path__ + "media/paper-airplane.451de0157b09e6b576b13e22b0d847c5.svg";